export function setAuthToken(username: string, password: string): string {
    const token = window.btoa(`${username}:${password}`);
    localStorage.setItem("token", JSON.stringify(token));
    return token;
  }
  
  export function getAuthToken(): string | null {
    return localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")!) : null;
  }